import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X } from "lucide-react";
import { LANDING } from "@/constants/testIds";

const NAV_LINKS = [
  { label: "Home", href: "#hero" },
  { label: "About", href: "#about" },
  { label: "Products", href: "#products" },
  { label: "Gallery", href: "#gallery" },
  { label: "Clientele", href: "#clientele" },
  { label: "Contact", href: "#contact" },
];

const Navbar = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const handleNav = (href) => {
    setOpen(false);
    document.querySelector(href)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <>
      <header
        className={`fixed top-0 left-0 right-0 z-50 bg-white border-b border-slate-200 transition-shadow duration-300 ${
          scrolled ? "shadow-sm" : ""
        }`}
      >
        <nav className="max-w-[1600px] mx-auto flex items-center justify-between px-6 sm:px-10 h-20">
          <a
            href="#hero"
            data-testid={LANDING.navLogo}
            onClick={(e) => {
              e.preventDefault();
              handleNav("#hero");
            }}
            className="flex items-center"
          >
            <img src="/sumatech-logo.png" alt="SUMATECH INNOVATIONS LLP" className="h-11 sm:h-14 w-auto" />
          </a>

          <div className="hidden lg:flex items-center gap-10">
            {NAV_LINKS.map((link) => (
              <button
                key={link.href}
                data-testid={`nav-link-${link.label.toLowerCase()}`}
                onClick={() => handleNav(link.href)}
                className="font-mono text-xs uppercase tracking-[0.2em] text-slate-600 transition-colors duration-200 hover:text-[#FF6F3C]"
              >
                {link.label}
              </button>
            ))}
          </div>

          <button
            data-testid={LANDING.navMobileToggle}
            onClick={() => setOpen((v) => !v)}
            className="lg:hidden text-slate-900"
            aria-label="Toggle menu"
          >
            {open ? <X size={26} /> : <Menu size={26} />}
          </button>
        </nav>
      </header>

      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0 z-40 bg-white flex flex-col items-start justify-center px-8 gap-6"
          >
            {NAV_LINKS.map((link, i) => (
              <motion.button
                key={link.href}
                data-testid={`nav-mobile-link-${link.label.toLowerCase()}`}
                initial={{ opacity: 0, x: -30 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ delay: i * 0.06 }}
                onClick={() => handleNav(link.href)}
                className="font-heading text-4xl uppercase font-bold text-slate-900 hover:text-[#FF6F3C] transition-colors"
              >
                {link.label}
              </motion.button>
            ))}
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
};

export default Navbar;
